/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VacationRequestsControllerSetPolicyOverrideRequest { 
    /**
     * Tipo de política a asignar, o null para revertir al cálculo automático
     */
    policyTypeOverride: VacationRequestsControllerSetPolicyOverrideRequest.PolicyTypeOverrideEnum | null;
}
export namespace VacationRequestsControllerSetPolicyOverrideRequest {
    export type PolicyTypeOverrideEnum = 'normal' | 'sindicalizado' | 'especial' | 'null';
    export const PolicyTypeOverrideEnum = {
        Normal: 'normal' as PolicyTypeOverrideEnum,
        Sindicalizado: 'sindicalizado' as PolicyTypeOverrideEnum,
        Especial: 'especial' as PolicyTypeOverrideEnum,
        Null: 'null' as PolicyTypeOverrideEnum
    };
}


